import { useOnlineStatus } from '@/hooks/useOnlineStatus'

export function OfflineIndicator() {
  const isOnline = useOnlineStatus()

  return (
    <span
      className={`app-status app-status--${isOnline ? 'good' : 'attention'}`}
      role="status"
      data-testid="connection-status"
    >
      <span aria-hidden="true">●</span>
      {isOnline ? 'Online' : 'Offline'}
    </span>
  )
}
